// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1D8zg","buttons":"Footer_buttons__3FdsG"};